export default {
  ADMIN: 'admin',
  DEFAULT: 'default'
};
